import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
const state = {
  appTheme: {
    themeColor: "#8FA959",
  },
  sdkInfo: {},
  ssoSDK: false,
};
const getters = {};
const mutations = {
  saveAppTheme(state, data) {
    state.appTheme = data;
  },
  upDatassoSDK(state, data) {
    state.ssoSDK = data;
  },
  saveSdkInfo(state, data) {
    state.sdkInfo = data;
  },
};
const actions = {
  //自定义触发mutations里函数的方法，context与store 实例具有相同方法和属性
};

export default {
  state,
  getters,
  actions,
  mutations,
};
